export function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#4285F4"
        d="M23.49 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.47c-.28 1.4-1.07 2.59-2.28 3.39v2.83h3.69c2.16-1.99 3.61-4.93 3.61-8.46z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.69-2.83c-1.02.69-2.33 1.1-4.24 1.1-3.26 0-6.02-2.2-7.01-5.16H1.18v3.24A11.99 11.99 0 0 0 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M4.99 14.2A7.18 7.18 0 0 1 4.62 12c0-.76.13-1.5.36-2.2V6.56H1.18A11.99 11.99 0 0 0 0 12c0 1.94.46 3.78 1.18 5.44l3.81-3.24z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.83 0 3.48.63 4.78 1.86l3.27-3.27C17.95 1.51 15.24 0 12 0 7.31 0 3.26 2.7 1.18 6.56l3.81 3.24C5.98 6.95 8.74 4.75 12 4.75z"
      />
    </svg>
  );
}

export function AppleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M17.05 20.28c-.98.95-2.05.86-3.08.43-1.09-.45-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.43C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"
      />
    </svg>
  );
}
